import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from './common/core/environment';
import { ToastService } from './common/notification/toast.service';

@Injectable()
export class PapaToast extends ErrorHandler {
  // pronounced 'pop a toast'
  private env: any;
  constructor(
    @Inject(ENVIRONMENT) environment: string,
    private readonly toastService: ToastService,
  ) {
    super();
    this.env = environment;
  }

  handleError(error: any) {
    if (this.env === 'local') {
      this.toastService.toast.next({
        message: 'Check the console for errors.',
        type: 'error',
        duration: 1000 * 3,
      });
    }
    super.handleError(error);
  }
}
